import { Punktestand } from '../components/Punktestand';
import { BingoBoard } from '../components/BingoBoard';
import { Zeitanzeige } from '../components/Zeitanzeige';
import { useLive } from '../lib/live';
import { useOverlaySeite } from '../lib/overlay';
import type { OverlayState } from '../lib/types';

/**
 * Das Bingo-Overlay für OBS.
 *
 * Durchsichtiger Hintergrund, keine Zierrahmen, nichts als Board und Zeit. Alles, was hier zu
 * sehen ist, kommt vom Server – die Seite rechnet nichts aus und braucht keine Anmeldung, nur den
 * Schlüssel der Lobby.
 */
export function BingoOverlay({ overlayKey, teamId }: { overlayKey: string; teamId?: string }) {
  useOverlaySeite();
  const live = useLive<OverlayState>({ overlayKey, ...(teamId ? { teamId } : {}) });

  if (live.fehler) return <div className="overlay-hint">{live.fehler}</div>;
  if (!live.state) return <div className="overlay-hint">verbindet …</div>;

  const { board, teams, scores, timer } = live.state;

  return (
    <div className="overlay bingo-overlay">
      <Zeitanzeige timer={timer} />
      {board ? (
        <BingoBoard board={board} teams={teams} scores={scores} />
      ) : (
        <div className="overlay-hint">Die Runde wird vorbereitet.</div>
      )}
      <div className="bingo-overlay-points"><Punktestand teams={teams} scores={scores} /></div>
    </div>
  );
}
